// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"dc7b9eb7","168":"ab643bee","478":"9c7ae4f1","522":"68ee61c3","784":"70c8e9a5","787":"4c6f280b","886":"cf2d8cb1","942":"b7ef4caa","961":"9ffae9c2"}[chunkId] + ".chunk.js";
};